import { useState, useEffect, useRef, useCallback } from 'react';
import { messagesAPI, customersAPI, channelsAPI, leadsAPI } from '../../services/api';
import api from '../../services/api';
import { useSocket } from '../../contexts/SocketContext';
import { useAuth } from '../../contexts/AuthContext';
import { format, isToday, isYesterday } from 'date-fns';
import {
  Search, Send, Bot, User, MoreVertical, Phone, Mail, Save,
  Tag, RefreshCw, MessageSquare, CheckCheck, AlertCircle, XCircle,
  PanelLeftClose, PanelLeftOpen, Pause, Play, UserPlus, X, Plus,
  Image, FileText, Film, Mic, Download, MapPin, Paperclip,
} from 'lucide-react';
import { useOutletContext, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

// Channel brand icons (small inline SVGs)
const ChannelIcon = ({ channel, size = 14 }) => {
  if (channel === 'whatsapp') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#25D366">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
  if (channel === 'telegram') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#0088cc">
      <path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
    </svg>
  );
  if (channel === 'facebook') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#1877F2">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );
  if (channel === 'instagram') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#E4405F">
      <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.882 0 1.441 1.441 0 012.882 0z"/>
    </svg>
  );
  if (channel === 'kakaotalk') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#3C1E1E">
      <path d="M12 1C5.373 1 0 5.244 0 10.5c0 3.394 2.262 6.382 5.668 8.053-.247.93-.896 3.37-.929 3.573 0 0-.019.158.084.218.103.06.224.013.224.013.296-.041 3.434-2.267 3.973-2.652A14.32 14.32 0 0012 20c6.627 0 12-4.244 12-9.5S18.627 1 12 1z"/>
    </svg>
  );
  if (channel === 'tiktok') return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#000000">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.52a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.34-6.34V8.62a8.2 8.2 0 004.76 1.52V6.69h-1z"/>
    </svg>
  );
  return <MessageSquare size={size} style={{ color: 'var(--text-muted)' }} />;
};

// Media base URL — strip /api suffix since /uploads is served at root
const MEDIA_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/api\/?$/, '');

// Render media content in chat messages
const MediaContent = ({ content }) => {
  const { type, mediaUrl, caption, fileName, location } = content;
  const fullUrl = mediaUrl?.startsWith('/') ? `${MEDIA_BASE}${mediaUrl}` : mediaUrl;

  if (type === 'image' && mediaUrl) {
    return (
      <div>
        <img src={fullUrl} alt={caption || 'Image'} style={{ maxWidth: 260, maxHeight: 260, borderRadius: 8, display: 'block', cursor: 'pointer' }} onClick={() => window.open(fullUrl, '_blank')} />
        {caption && <div style={{ marginTop: 6, fontSize: '0.85rem' }}>{caption}</div>}
      </div>
    );
  }

  if (type === 'video' && mediaUrl) {
    return (
      <div>
        <video src={fullUrl} controls style={{ maxWidth: 280, maxHeight: 220, borderRadius: 8, display: 'block' }} />
        {caption && <div style={{ marginTop: 6, fontSize: '0.85rem' }}>{caption}</div>}
      </div>
    );
  }

  if (type === 'audio' && mediaUrl) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 200 }}>
        <Mic size={16} style={{ color: 'var(--primary)', flexShrink: 0 }} />
        <audio src={fullUrl} controls style={{ width: '100%', height: 36 }} />
      </div>
    );
  }

  if (type === 'document' && mediaUrl) {
    return (
      <a href={fullUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', background: 'rgba(0,0,0,0.04)', borderRadius: 8, textDecoration: 'none', color: 'inherit' }}>
        <FileText size={24} style={{ color: 'var(--primary)', flexShrink: 0 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '0.82rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fileName || 'Document'}</div>
          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>Tap to download</div>
        </div>
        <Download size={16} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
      </a>
    );
  }

  if (type === 'location' && location) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <MapPin size={16} style={{ color: '#ef4444', flexShrink: 0 }} />
        <span style={{ fontSize: '0.85rem' }}>{location.name || `${location.latitude}, ${location.longitude}`}</span>
      </div>
    );
  }

  if (type === 'sticker') {
    return <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>Sticker</div>;
  }

  // Fallback for media without URL
  const icons = { image: <Image size={14} />, video: <Film size={14} />, audio: <Mic size={14} />, document: <FileText size={14} /> };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: 'var(--text-muted)', fontStyle: 'italic', fontSize: '0.85rem' }}>
      {icons[type] || null} {type} message
    </div>
  );
};

export default function InboxPage() {
  const { merchant, user } = useAuth();
  const { on, off, emit } = useSocket();
  const { sidebarHidden, toggleSidebar } = useOutletContext() || {};
  const location = useLocation();

  const [conversations, setConversations] = useState([]);
  const [activeCustomer, setActiveCustomer] = useState(null);
  const [messages, setMessages] = useState([]);
  const [channels, setChannels] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('open');
  const [messageText, setMessageText] = useState('');
  const [sending, setSending] = useState(false);
  const [loadingConvs, setLoadingConvs] = useState(true);
  const [loadingMsgs, setLoadingMsgs] = useState(false);
  const [showLabelMenu, setShowLabelMenu] = useState(false);
  const [aiThinking, setAiThinking] = useState(false);
  const aiThinkingTimerRef = useRef(null);
  const [newLabel, setNewLabel] = useState('');
  const [newLabelColor, setNewLabelColor] = useState('#6366f1');
  const [labelFilter, setLabelFilter] = useState('');
  const [channelFilter, setChannelFilter] = useState('');
  const [allTags, setAllTags] = useState([]);
  const [customLabelColors, setCustomLabelColors] = useState(() => {
    try { return JSON.parse(localStorage.getItem('inbox_label_colors') || '{}'); } catch { return {}; }
  });
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const pendingOpenIdRef = useRef(location.state?.customerId || null);

  const PRESET_LABELS = [
    { name: 'high priority', color: '#ef4444', bg: '#fee2e2' },
    { name: 'low priority', color: '#f59e0b', bg: '#fef3c7' },
    { name: 'follow up', color: '#3b82f6', bg: '#dbeafe' },
    { name: 'vip', color: '#8b5cf6', bg: '#ede9fe' },
    { name: 'new customer', color: '#10b981', bg: '#d1fae5' },
  ];

  const saveColor = (labelName, hexColor) => {
    const updated = { ...customLabelColors, [labelName.toLowerCase()]: { color: hexColor, bg: hexColor + '25' } };
    setCustomLabelColors(updated);
    localStorage.setItem('inbox_label_colors', JSON.stringify(updated));
  };

  const getLabelStyle = (tag) => {
    const saved = customLabelColors[tag.toLowerCase()];
    if (saved) return { background: saved.bg, color: saved.color, border: `1px solid ${saved.color}50` };
    const preset = PRESET_LABELS.find(p => p.name === tag.toLowerCase());
    return preset
      ? { background: preset.bg, color: preset.color, border: `1px solid ${preset.color}30` }
      : { background: 'var(--bg)', color: 'var(--text-muted)', border: '1px solid var(--border)' };
  };

  // Detect phone/email in messages
  const detectContactInfo = (msgs) => {
    const phoneRe = /(?:\+?\d{1,4}[\s-]?)?\(?\d{2,4}\)?[\s.-]?\d{3,4}[\s.-]?\d{3,5}/g;
    const emailRe = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    const phones = new Set();
    const emails = new Set();
    msgs.filter(m => m.direction === 'inbound' && m.content?.text).forEach(m => {
      (m.content.text.match(phoneRe) || []).forEach(p => { if (p.replace(/\D/g, '').length >= 7) phones.add(p.trim()); });
      (m.content.text.match(emailRe) || []).forEach(e => emails.add(e.trim()));
    });
    return { phones: [...phones], emails: [...emails] };
  };

  const fetchConversations = useCallback(async () => {
    try {
      const { data } = await messagesAPI.getInbox({ search: searchQuery, status: statusFilter, limit: 30 });
      setConversations(data.data.conversations);
    } catch (_) {}
    finally { setLoadingConvs(false); }
  }, [searchQuery, statusFilter]);

  useEffect(() => {
    fetchConversations();
    channelsAPI.list().then(({ data }) => setChannels(data.data)).catch(() => {});
    customersAPI.getTags().then(({ data }) => setAllTags(data.data || [])).catch(() => {});
  }, [fetchConversations]);

  // Auto-open specific customer conversation when navigated from Customers page
  useEffect(() => {
    if (loadingConvs || !pendingOpenIdRef.current) return;
    const found = conversations.find(c => c._id === pendingOpenIdRef.current);
    if (found) {
      pendingOpenIdRef.current = null;
      openConversation(found);
    }
  }, [loadingConvs, conversations]); // intentionally omitting openConversation to avoid loop

  // Real-time: new message
  useEffect(() => {
    const handleNewMessage = (payload) => {
      const { message, customer } = payload;
      setConversations(prev => {
        const existing = prev.find(c => c._id === customer._id);
        if (existing) {
          return [
            { ...existing, lastMessage: message, unreadCount: message.direction === 'inbound' ? (existing.unreadCount || 0) + 1 : existing.unreadCount },
            ...prev.filter(c => c._id !== customer._id),
          ];
        }
        return [{ ...customer, lastMessage: message, unreadCount: 1 }, ...prev];
      });

      if (activeCustomer?._id === customer._id) {
        setMessages(prev => [...prev, message]);
        scrollToBottom();
        emit('messages:read', { customerId: customer._id, merchantId: merchant?._id });
      }

      // AI thinking indicator: show after an inbound customer message, hide
      // when the AI's outbound reply arrives. Only applies when AI is active
      // (customer not handed to agent / not blocked / not pending approval).
      const eligibleForAI = !customer.handedToAgent
        && !customer.isBlocked
        && customer.approvalStatus !== 'pending'
        && customer.approvalStatus !== 'rejected';

      if (activeCustomer?._id === customer._id) {
        if (message.direction === 'inbound' && eligibleForAI) {
          setAiThinking(true);
          if (aiThinkingTimerRef.current) clearTimeout(aiThinkingTimerRef.current);
          // Safety timeout in case AI never replies (error, off-hours, etc.)
          aiThinkingTimerRef.current = setTimeout(() => setAiThinking(false), 30000);
          scrollToBottom();
        } else if (message.direction === 'outbound') {
          setAiThinking(false);
          if (aiThinkingTimerRef.current) clearTimeout(aiThinkingTimerRef.current);
        }
      }
    };

    const handleChatEnded = ({ customerId }) => {
      setConversations(prev => prev.filter(c => c._id !== customerId));
      if (activeCustomer?._id === customerId) {
        setActiveCustomer(null);
        setMessages([]);
      }
    };

    on('message:new', handleNewMessage);
    on('chat:ended', handleChatEnded);
    return () => {
      off('message:new', handleNewMessage);
      off('chat:ended', handleChatEnded);
      if (aiThinkingTimerRef.current) clearTimeout(aiThinkingTimerRef.current);
    };
  }, [on, off, emit, activeCustomer, merchant]);

  // Close label menu on outside click
  useEffect(() => {
    if (!showLabelMenu) return;
    const handler = (e) => { if (!e.target.closest('[data-label-menu]')) setShowLabelMenu(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showLabelMenu]);

  const openConversation = async (customer) => {
    setActiveCustomer(customer);
    setAiThinking(false);
    if (aiThinkingTimerRef.current) clearTimeout(aiThinkingTimerRef.current);
    setLoadingMsgs(true);
    emit('join:conversation', customer._id);
    emit('messages:read', { customerId: customer._id, merchantId: merchant?._id });

    setConversations(prev => prev.map(c => c._id === customer._id ? { ...c, unreadCount: 0 } : c));

    try {
      const { data } = await messagesAPI.getConversation(customer._id);
      setMessages(data.data.messages);
      scrollToBottom(true);
    } catch (_) {}
    finally { setLoadingMsgs(false); }
    inputRef.current?.focus();
  };

  const sendMessage = async () => {
    if (!messageText.trim() || !activeCustomer || sending) return;

    // Use the channelId from the last message, or find matching channel by type
    const lastMsg = messages[messages.length - 1];
    const customerChannel = activeCustomer.channelIds?.[0]?.channel;
    const channelId = lastMsg?.channelId
      || channels.find(c => c.type === customerChannel && c.status === 'connected')?._id
      || channels.find(c => c.type === customerChannel)?._id;

    if (!channelId) {
      toast.error(`No ${customerChannel || ''} channel found. Please connect a channel first.`);
      return;
    }

    setSending(true);
    const text = messageText.trim();
    setMessageText('');
    try {
      await messagesAPI.send({ customerId: activeCustomer._id, channelId, text });
    } catch (_) {}
    finally { setSending(false); }
  };

  const fileInputRef = useRef(null);
  const sendMediaFile = async (file) => {
    if (!file || !activeCustomer || sending) return;
    const lastMsg = messages[messages.length - 1];
    const customerChannel = activeCustomer.channelIds?.[0]?.channel;
    const channelId = lastMsg?.channelId
      || channels.find(c => c.type === customerChannel && c.status === 'connected')?._id
      || channels.find(c => c.type === customerChannel)?._id;
    if (!channelId) { toast.error('No channel found'); return; }

    setSending(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('customerId', activeCustomer._id);
      fd.append('channelId', channelId);
      await messagesAPI.sendMedia(fd);
    } catch (_) { toast.error('Failed to send file'); }
    finally { setSending(false); }
  };

  const endChat = async () => {
    if (!activeCustomer) return;
    try {
      await messagesAPI.endChat(activeCustomer._id);
      setConversations(prev => prev.filter(c => c._id !== activeCustomer._id));
      setActiveCustomer(null);
      setMessages([]);
      toast.success('Chat ended');
    } catch (_) {}
  };

  const toggleAI = async () => {
    if (!activeCustomer) return;
    const newValue = !activeCustomer.handedToAgent;
    try {
      await api.patch(`/customers/${activeCustomer._id}`, { handedToAgent: newValue });
      setActiveCustomer(prev => ({ ...prev, handedToAgent: newValue }));
      setConversations(prev => prev.map(c => c._id === activeCustomer._id ? { ...c, handedToAgent: newValue } : c));
      toast.success(newValue ? 'AI paused — you are in control' : 'AI resumed');
    } catch (_) { toast.error('Failed'); }
  };

  const handleApproval = async (status) => {
    if (!activeCustomer) return;
    try {
      await customersAPI.setApproval(activeCustomer._id, status);
      setActiveCustomer(prev => ({ ...prev, approvalStatus: status }));
      setConversations(prev => prev.map(c => c._id === activeCustomer._id ? { ...c, approvalStatus: status } : c));
      toast.success(status === 'approved' ? 'Customer approved — AI will now respond' : 'Customer rejected');
    } catch (_) { toast.error('Failed'); }
  };

  const addLabel = async (tag) => {
    if (!activeCustomer) return;
    const tags = [...new Set([...(activeCustomer.tags || []), tag])];
    try {
      await customersAPI.update(activeCustomer._id, { tags });
      setActiveCustomer(prev => ({ ...prev, tags }));
      setConversations(prev => prev.map(c => c._id === activeCustomer._id ? { ...c, tags } : c));
      if (!allTags.includes(tag)) setAllTags(prev => [...prev, tag]);
      toast.success(`Label "${tag}" added`);
    } catch (_) {}
  };

  const removeLabel = async (tag) => {
    if (!activeCustomer) return;
    const tags = (activeCustomer.tags || []).filter(t => t !== tag);
    try {
      await customersAPI.update(activeCustomer._id, { tags });
      setActiveCustomer(prev => ({ ...prev, tags }));
      setConversations(prev => prev.map(c => c._id === activeCustomer._id ? { ...c, tags } : c));
    } catch (_) {}
  };

  const saveContactInfo = async (field, value) => {
    if (!activeCustomer) return;
    try {
      await customersAPI.update(activeCustomer._id, { [field]: value });
      setActiveCustomer(prev => ({ ...prev, [field]: value }));
      setConversations(prev => prev.map(c => c._id === activeCustomer._id ? { ...c, [field]: value } : c));
      toast.success(`${field === 'phone' ? 'Phone' : 'Email'} saved to contact`);
    } catch (_) { toast.error('Failed to save'); }
  };

  const convertToLead = async () => {
    if (!activeCustomer) return;
    try {
      await leadsAPI.fromCustomer({ customerId: activeCustomer._id });
      toast.success('Lead created and added to CRM!');
    } catch (err) {
      const msg = err.response?.data?.message;
      if (msg?.includes('already exists')) toast.error('Lead already exists for this customer');
      else toast.error(msg || 'Failed to convert');
    }
  };

  const scrollToBottom = (instant = false) => {
    setTimeout(() => messagesEndRef.current?.scrollIntoView({ behavior: instant ? 'instant' : 'smooth' }), 50);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  const formatTime = (date) => {
    const d = new Date(date);
    if (isToday(d)) return format(d, 'HH:mm');
    if (isYesterday(d)) return 'Yesterday';
    return format(d, 'MMM d');
  };

  const formatMessageTime = (date) => format(new Date(date), 'HH:mm');

  const statusOptions = [
    { value: 'open', label: 'Live' },
    { value: 'needs_agent', label: 'Needs Assistant' },
    { value: 'pending', label: 'Pending' },
    { value: 'resolved', label: 'Ended' },
    { value: '', label: 'All' },
  ];

  return (
    <div className="inbox-layout" style={{ height: '100vh' }}>
      {/* Conversation List */}
      <div className="conversation-list">
        <div style={{ padding: '14px 14px 10px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
            <button onClick={toggleSidebar} title={sidebarHidden ? 'Show sidebar' : 'Hide sidebar'}
              style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '5px 7px', cursor: 'pointer', color: 'var(--text-muted)', display: 'flex', alignItems: 'center' }}>
              {sidebarHidden ? <PanelLeftOpen size={16} /> : <PanelLeftClose size={16} />}
            </button>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: '1rem' }}>Inbox</div>
          </div>
          <div className="search-box">
            <Search size={14} />
            <input className="form-input" style={{ fontSize: '0.82rem', padding: '7px 10px 7px 32px' }}
              placeholder="Search conversations…" value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)} />
          </div>
          <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
            {statusOptions.map(opt => (
              <button key={opt.value}
                className={`btn btn-sm ${statusFilter === opt.value ? 'btn-primary' : 'btn-secondary'}`}
                style={{ padding: '3px 9px', fontSize: '0.75rem' }}
                onClick={() => setStatusFilter(opt.value)}>
                {opt.label}
              </button>
            ))}
          </div>
          {/* Channel filter */}
          {channels.length > 0 && (() => {
            const presentTypes = [...new Set(conversations.map(c => c.channelIds?.[0]?.channel).filter(Boolean))];
            if (presentTypes.length < 2) return null;
            return (
              <div style={{ display: 'flex', gap: 4, marginTop: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                {channelFilter && (
                  <button onClick={() => setChannelFilter('')}
                    style={{ padding: '2px 7px', borderRadius: 99, fontSize: '0.68rem', fontWeight: 600, cursor: 'pointer', background: '#fee2e2', color: '#ef4444', border: 'none' }}>
                    ✕
                  </button>
                )}
                {presentTypes.map(type => (
                  <button key={type} onClick={() => setChannelFilter(channelFilter === type ? '' : type)}
                    style={{ padding: '2px 8px', borderRadius: 99, fontSize: '0.68rem', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4,
                      background: channelFilter === type ? 'var(--primary)' : 'var(--bg-secondary)',
                      color: channelFilter === type ? '#fff' : 'var(--text-muted)',
                      border: channelFilter === type ? 'none' : '1px solid var(--border)',
                      opacity: channelFilter && channelFilter !== type ? 0.5 : 1 }}>
                    <ChannelIcon channel={type} size={11} />
                    {type}
                  </button>
                ))}
              </div>
            );
          })()}
          {/* Label filter */}
          {allTags.length > 0 && (
            <div style={{ display: 'flex', gap: 4, marginTop: 6, flexWrap: 'wrap', alignItems: 'center' }}>
              <Tag size={11} style={{ color: 'var(--text-muted)' }} />
              {labelFilter && (
                <button onClick={() => setLabelFilter('')}
                  style={{ padding: '2px 7px', borderRadius: 99, fontSize: '0.68rem', fontWeight: 600, cursor: 'pointer', background: '#fee2e2', color: '#ef4444', border: 'none' }}>
                  Clear
                </button>
              )}
              {[...PRESET_LABELS.map(p => p.name), ...allTags.filter(t => !PRESET_LABELS.find(p => p.name === t.toLowerCase()))].filter((v, i, a) => a.indexOf(v) === i).slice(0, 8).map(tag => (
                <button key={tag} onClick={() => setLabelFilter(labelFilter === tag ? '' : tag)}
                  style={{ padding: '2px 7px', borderRadius: 99, fontSize: '0.68rem', fontWeight: 600, cursor: 'pointer', ...getLabelStyle(tag), opacity: labelFilter && labelFilter !== tag ? 0.5 : 1 }}>
                  {tag}
                </button>
              ))}
            </div>
          )}
        </div>

        {loadingConvs ? (
          <div className="flex-center" style={{ padding: 40 }}><div className="spinner" /></div>
        ) : conversations.length === 0 ? (
          <div className="empty-state">
            <MessageSquare size={32} />
            <h3>No conversations</h3>
            <p>Messages will appear here</p>
          </div>
        ) : conversations
          .filter(c => !labelFilter || (c.tags || []).some(t => t.toLowerCase() === labelFilter.toLowerCase()))
          .filter(c => !channelFilter || c.channelIds?.[0]?.channel === channelFilter)
          .map(conv => (
          <div key={conv._id} className={`conversation-item ${activeCustomer?._id === conv._id ? 'active' : ''}`}
            onClick={() => openConversation(conv)}>
            <div style={{ position: 'relative' }}>
              <div className="avatar avatar-sm">{(conv.name || '?')[0].toUpperCase()}</div>
              {conv.channelIds?.[0]?.channel && (
                <div style={{
                  position: 'absolute', bottom: -2, right: -2,
                  width: 18, height: 18, borderRadius: '50%', background: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  border: '1.5px solid var(--border)',
                }}>
                  <ChannelIcon channel={conv.channelIds[0].channel} size={10} />
                </div>
              )}
            </div>
            <div style={{ flex: 1, overflow: 'hidden' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <span className="conversation-name">{conv.name}</span>
                <span className="conversation-time">{conv.lastMessage ? formatTime(conv.lastMessage.createdAt) : ''}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 4 }}>
                <div className="conversation-preview">
                  {conv.lastMessage?.sender?.type === 'ai' && <Bot size={10} style={{ display: 'inline', marginRight: 3, color: 'var(--primary)' }} />}
                  {conv.lastMessage?.content?.text || (conv.lastMessage?.content?.type === 'image' ? '📷 Photo' : conv.lastMessage?.content?.type === 'video' ? '🎥 Video' : conv.lastMessage?.content?.type === 'audio' ? '🎤 Voice' : conv.lastMessage?.content?.type === 'document' ? '📄 ' + (conv.lastMessage?.content?.fileName || 'Document') : conv.lastMessage?.content?.caption || '[media]')}
                </div>
                {conv.approvalStatus === 'pending' && <span style={{ fontSize: '0.6rem', padding: '1px 5px', borderRadius: 99, background: '#fef3c7', color: '#92400e', fontWeight: 700, whiteSpace: 'nowrap' }}>Pending</span>}
                {conv.unreadCount > 0 && <span className="unread-badge">{conv.unreadCount}</span>}
              </div>
              {conv.tags?.length > 0 && (
                <div style={{ display: 'flex', gap: 3, marginTop: 3 }}>
                  {conv.tags.slice(0, 3).map(tag => (
                    <span key={tag} style={{ fontSize: '0.63rem', padding: '1px 6px', borderRadius: 99, fontWeight: 600, ...getLabelStyle(tag) }}>{tag}</span>
                  ))}
                  {conv.tags.length > 3 && <span style={{ fontSize: '0.63rem', color: 'var(--text-muted)' }}>+{conv.tags.length - 3}</span>}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Chat Area */}
      {activeCustomer ? (
        <div className="chat-area">
          {/* Header */}
          <div className="chat-header">
            <div className="avatar">{(activeCustomer.name || '?')[0].toUpperCase()}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: '0.95rem' }}>{activeCustomer.name}</div>
              <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', display: 'flex', gap: 10 }}>
                {activeCustomer.channelIds?.map(ch => (
                  <span key={ch.channel} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <ChannelIcon channel={ch.channel} size={13} />
                    <span style={{ textTransform: 'capitalize' }}>{ch.channel}</span>
                    <span style={{ color: 'var(--text-placeholder)' }}>·</span>
                    <span>{ch.externalId}</span>
                  </span>
                ))}
              </div>
            </div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
              {activeCustomer.isBlocked && <span className="badge badge-red"><AlertCircle size={10} /> Blocked</span>}
              {activeCustomer.approvalStatus === 'pending' && <span style={{ fontSize: '0.7rem', padding: '2px 8px', borderRadius: 99, background: '#fef3c7', color: '#92400e', fontWeight: 700, border: '1px solid #fcd34d' }}>Pending Approval</span>}
              {activeCustomer.approvalStatus === 'rejected' && <span style={{ fontSize: '0.7rem', padding: '2px 8px', borderRadius: 99, background: '#fee2e2', color: '#991b1b', fontWeight: 700, border: '1px solid #fca5a5' }}>Rejected</span>}
              {activeCustomer.handedToAgent
                ? <button className="btn btn-secondary btn-sm" onClick={toggleAI} title="Resume AI" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Play size={13} style={{ color: 'var(--green)' }} /> Resume AI
                  </button>
                : <button className="btn btn-secondary btn-sm" onClick={toggleAI} title="Pause AI — take over manually" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Pause size={13} style={{ color: 'var(--red)' }} /> Pause AI
                  </button>
              }
              <button className="btn btn-secondary btn-sm" onClick={convertToLead} title="Convert to Lead" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <UserPlus size={13} /> Lead
              </button>
              <div style={{ position: 'relative' }} data-label-menu>
                <button className="btn btn-secondary btn-sm" onClick={() => setShowLabelMenu(!showLabelMenu)} title="Labels" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <Tag size={13} /> Label
                </button>
                {showLabelMenu && (
                  <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: 4, background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: 10, boxShadow: '0 4px 16px rgba(0,0,0,0.1)', width: 220, zIndex: 50, padding: '8px 0' }}>
                    <div style={{ padding: '4px 12px 6px', fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase' }}>Labels</div>
                    {/* Current labels */}
                    {(activeCustomer.tags || []).length > 0 && (
                      <div style={{ padding: '4px 12px 8px', display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {activeCustomer.tags.map(tag => (
                          <span key={tag} style={{ fontSize: '0.7rem', padding: '2px 8px', borderRadius: 99, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 3, ...getLabelStyle(tag) }}
                            onClick={() => removeLabel(tag)}>
                            {tag} <X size={10} />
                          </span>
                        ))}
                      </div>
                    )}
                    <div style={{ borderTop: '1px solid var(--border)', margin: '0' }} />
                    {/* All labels (preset + any saved custom) */}
                    {[...PRESET_LABELS.map(p => p.name), ...Object.keys(customLabelColors).filter(n => !PRESET_LABELS.find(p => p.name === n))]
                      .filter(name => !(activeCustomer.tags || []).includes(name))
                      .map(name => {
                        const style = getLabelStyle(name);
                        return (
                          <div key={name} style={{ display: 'flex', alignItems: 'center', padding: '0 8px 0 12px' }}>
                            <button onClick={() => addLabel(name)}
                              style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.82rem', color: 'var(--text)', textAlign: 'left', padding: '6px 0' }}>
                              <span style={{ width: 10, height: 10, borderRadius: '50%', background: style.color, flexShrink: 0 }} />
                              {name}
                            </button>
                            <label title="Change color" style={{ cursor: 'pointer', flexShrink: 0, width: 18, height: 18, borderRadius: 4, border: `1px solid ${style.color}`, background: style.background, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
                              <span style={{ fontSize: '0.6rem', color: style.color, fontWeight: 700, pointerEvents: 'none' }}>✎</span>
                              <input type="color" value={customLabelColors[name]?.color || (PRESET_LABELS.find(p => p.name === name)?.color || '#6366f1')}
                                onChange={e => saveColor(name, e.target.value)}
                                style={{ opacity: 0, position: 'absolute', inset: 0, width: '100%', height: '100%', cursor: 'pointer' }} />
                            </label>
                          </div>
                        );
                      })}
                    {/* Custom label */}
                    <div style={{ borderTop: '1px solid var(--border)', padding: '8px 10px 4px' }}>
                      <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                        <label title="Pick color" style={{ cursor: 'pointer', flexShrink: 0, width: 26, height: 26, borderRadius: 6, background: newLabelColor + '25', border: `2px solid ${newLabelColor}`, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
                          <span style={{ width: 10, height: 10, borderRadius: '50%', background: newLabelColor, display: 'block' }} />
                          <input type="color" value={newLabelColor} onChange={e => setNewLabelColor(e.target.value)}
                            style={{ opacity: 0, position: 'absolute', inset: 0, width: '100%', height: '100%', cursor: 'pointer' }} />
                        </label>
                        <input className="form-input" placeholder="New label name" value={newLabel} onChange={e => setNewLabel(e.target.value)}
                          onKeyDown={e => { if (e.key === 'Enter' && newLabel.trim()) { addLabel(newLabel.trim()); saveColor(newLabel.trim(), newLabelColor); setNewLabel(''); } }}
                          style={{ fontSize: '0.78rem', padding: '5px 8px', flex: 1 }} />
                        <button className="btn btn-primary btn-sm" style={{ padding: '4px 8px' }}
                          onClick={() => { if (newLabel.trim()) { addLabel(newLabel.trim()); saveColor(newLabel.trim(), newLabelColor); setNewLabel(''); } }}>
                          <Plus size={13} />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <button className="btn btn-ghost btn-icon" onClick={fetchConversations} title="Refresh"><RefreshCw size={15} /></button>
              <button className="btn btn-danger btn-sm" onClick={endChat} title="End chat">
                <XCircle size={13} /> End Chat
              </button>
            </div>
          </div>

          {/* Detected contact info bar */}
          {(() => {
            const detected = detectContactInfo(messages);
            const hasNew = detected.phones.some(p => p !== activeCustomer.phone) || detected.emails.some(e => e !== activeCustomer.email);
            if (!hasNew) return null;
            return (
              <div style={{ padding: '6px 16px', background: '#eff6ff', borderBottom: '1px solid #bfdbfe', display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', fontSize: '0.78rem' }}>
                <span style={{ color: '#1d4ed8', fontWeight: 600 }}>Detected:</span>
                {detected.phones.filter(p => p !== activeCustomer.phone).map(p => (
                  <button key={p} onClick={() => saveContactInfo('phone', p)}
                    style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '3px 8px', borderRadius: 6, border: '1px solid #93c5fd', background: '#fff', color: '#1d4ed8', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer' }}>
                    <Phone size={11} /> {p} <Save size={11} />
                  </button>
                ))}
                {detected.emails.filter(e => e !== activeCustomer.email).map(e => (
                  <button key={e} onClick={() => saveContactInfo('email', e)}
                    style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '3px 8px', borderRadius: 6, border: '1px solid #93c5fd', background: '#fff', color: '#1d4ed8', fontSize: '0.75rem', fontWeight: 600, cursor: 'pointer' }}>
                    <Mail size={11} /> {e} <Save size={11} />
                  </button>
                ))}
              </div>
            );
          })()}

          {/* Messages */}
          <div className="chat-messages">
            {loadingMsgs ? (
              <div className="flex-center" style={{ flex: 1 }}><div className="spinner" /></div>
            ) : messages.length === 0 ? (
              <div className="empty-state" style={{ flex: 1 }}>
                <MessageSquare size={36} /><h3>No messages yet</h3><p>Start the conversation!</p>
              </div>
            ) : (
              <>
                {messages.map((msg, i) => {
                  const isOutbound = msg.direction === 'outbound';
                  const isAI = msg.sender?.type === 'ai';
                  return (
                    <div key={msg._id || i} className={`message-wrapper ${isOutbound ? 'outbound' : 'inbound'}`}>
                      <div className={`message-bubble ${isOutbound ? 'outbound' : 'inbound'} ${isAI ? 'ai' : ''}`}>
                        {msg.content?.type && msg.content.type !== 'text' && (msg.content.mediaUrl || msg.content.location)
                          ? <MediaContent content={msg.content} />
                          : null}
                        {msg.content?.text || (!msg.content?.mediaUrl && !msg.content?.location && msg.content?.type !== 'text'
                          ? <span style={{ fontStyle: 'italic', color: 'var(--text-muted)' }}>{msg.content?.caption || `[${msg.content?.type || 'media'} message]`}</span>
                          : null)}
                      </div>
                      <div className="message-meta">
                        {formatMessageTime(msg.createdAt)}
                        {msg.channel && <ChannelIcon channel={msg.channel} size={10} />}
                        {isAI && <><Bot size={10} style={{ color: 'var(--primary)' }} /><span style={{ color: 'var(--primary)' }}>AI</span></>}
                        {isOutbound && !isAI && (
                          <span style={{ color: 'var(--text-muted)' }}>
                            {msg.sender?.name || user?.name || merchant?.businessName || 'Agent'}
                          </span>
                        )}
                        {isOutbound && msg.status === 'read' && <CheckCheck size={12} style={{ color: 'var(--primary)' }} />}
                        {isOutbound && msg.status === 'delivered' && <CheckCheck size={12} style={{ color: 'var(--text-muted)' }} />}
                      </div>
                    </div>
                  );
                })}
                {aiThinking && !activeCustomer.handedToAgent && (
                  <div className="message-wrapper inbound" aria-live="polite">
                    <div className="message-bubble inbound ai" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '10px 14px' }}>
                      <Bot size={14} style={{ color: 'var(--primary)' }} />
                      <span style={{ fontSize: '0.82rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>AI is typing</span>
                      <span className="ai-typing-dots" aria-hidden="true">
                        <span /><span /><span />
                      </span>
                    </div>
                  </div>
                )}
                <div ref={messagesEndRef} />
              </>
            )}
          </div>

          {/* Pending approval banner */}
          {activeCustomer.approvalStatus === 'pending' && (
            <div style={{ padding: '10px 16px', background: '#fffbeb', borderTop: '1px solid #fcd34d', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
              <AlertCircle size={16} style={{ color: '#d97706', flexShrink: 0 }} />
              <div style={{ flex: 1, fontSize: '0.82rem', color: '#92400e', fontWeight: 500 }}>
                This customer is waiting for approval. AI will not respond until you approve them.
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button className="btn btn-sm" style={{ background: '#22c55e', color: '#fff', border: 'none', fontWeight: 700, fontSize: '0.78rem' }}
                  onClick={() => handleApproval('approved')}>
                  ✓ Approve
                </button>
                <button className="btn btn-sm" style={{ background: '#ef4444', color: '#fff', border: 'none', fontWeight: 700, fontSize: '0.78rem' }}
                  onClick={() => handleApproval('rejected')}>
                  ✕ Reject
                </button>
              </div>
            </div>
          )}

          {activeCustomer.approvalStatus === 'rejected' && (
            <div style={{ padding: '10px 16px', background: '#fef2f2', borderTop: '1px solid #fca5a5', display: 'flex', alignItems: 'center', gap: 12 }}>
              <XCircle size={16} style={{ color: '#ef4444', flexShrink: 0 }} />
              <div style={{ flex: 1, fontSize: '0.82rem', color: '#991b1b', fontWeight: 500 }}>Customer was rejected. AI will not respond.</div>
              <button className="btn btn-sm" style={{ background: '#22c55e', color: '#fff', border: 'none', fontWeight: 700, fontSize: '0.78rem' }}
                onClick={() => handleApproval('approved')}>
                ✓ Approve Instead
              </button>
            </div>
          )}

          {/* Input */}
          {activeCustomer.isBlocked ? (
            <div className="chat-input-area">
              <div className="alert alert-error" style={{ marginBottom: 0 }}>
                <AlertCircle size={15} /> This customer is blocked. Unblock to send messages.
              </div>
            </div>
          ) : (
            <div className="chat-input-area">
              <div className="chat-input-row">
                <input type="file" ref={fileInputRef} style={{ display: 'none' }}
                  accept="image/*,video/*,audio/*,.pdf,.docx,.xlsx,.csv,.txt,.doc,.xls"
                  onChange={e => { if (e.target.files[0]) sendMediaFile(e.target.files[0]); e.target.value = ''; }}
                />
                <button className="btn btn-ghost btn-icon" onClick={() => fileInputRef.current?.click()} disabled={sending}
                  title="Attach file" style={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0 }}>
                  <Paperclip size={16} />
                </button>
                <textarea
                  ref={inputRef}
                  className="chat-input"
                  placeholder="Type a message… (Enter to send, Shift+Enter for new line)"
                  value={messageText}
                  onChange={e => setMessageText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  rows={1}
                />
                <button className="btn btn-primary btn-icon" onClick={sendMessage} disabled={sending || !messageText.trim()}
                  style={{ width: 40, height: 40, borderRadius: '50%', flexShrink: 0 }}>
                  <Send size={16} />
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex-center" style={{ flex: 1, flexDirection: 'column', gap: 12, color: 'var(--text-muted)' }}>
          <MessageSquare size={48} strokeWidth={1} />
          <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600 }}>Select a conversation</div>
          <div style={{ fontSize: '0.85rem' }}>Choose a conversation from the left to start chatting</div>
        </div>
      )}
    </div>
  );
}
